export default __webpack_public_path__ + "static/media/6.aa6c9569.jpg";